"use strict";

module.exports = {
  API: {
    iybweb: {
      host: 'https://uat.iyunbao.com/iyb'
    },
    club: {
      host: 'https://api-uat.iyunbao.com/club'
    },
    api: {
      host: 'https://api-uat.iyunbao.com'
    },
    hawkeye: {
      host: 'https://hawkeye-uat.iyunbao.com'
    },
    gw: {
      host: 'https://gw-uat.baoinsurance.com'
    }
  },
  URL: {
    api: 'https://api-uat.iyunbao.com',
    isee: '//static.iyb.tm/isee/test/eye.js'
  }
};